import { faCirclePlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form } from "react-bootstrap";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import { useEffect, useState } from "react";
import { Controller, useForm, useFieldArray } from "react-hook-form";

import {
  Create,
  GetAll,
} from "../../../../../../../../src/features/admin/quality_management/structural_requirement/management_data/Slice";
import { useDispatch, useSelector } from "react-redux";
function ISStandard_Form({ handleClose, fetchCustomers }) {
  const defaultValues = {
    name: "",
    remark: "",
    documents: [{ file: null }],
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
    watch,
    getValues,
  } = useForm({
    defaultValues,
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "documents",
  });

  const [showError, setShowError] = useState({});
  const [previews, setPreviews] = useState({});
  const [success, setSuccess] = useState(false);

  const dispatch = useDispatch();

  // 🔹 file change + preview
  const handleFileChange = (file, index) => {
    setValue(`documents.${index}.file`, file);
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setPreviews((prev) => ({ ...prev, [index]: previewUrl }));
    }
  };

  const handleCancel = () => {
    reset(defaultValues);
    setPreviews({});
  };

  // 🔹 submit
  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      formData.append("name", data.name);
      formData.append("management_data_id", 3);
      formData.append("remark", data.remark);

      data.documents.forEach((file, index) => {
        if (file && file.length > 0) {
          formData.append("documents", file[0]);
        }
      });

      const res = await dispatch(Create(formData));

      if (res.meta.requestStatus === "fulfilled") {
        // await dispatch(GetAll());
        fetchCustomers();
        reset({
          name: "",
          remark: "",
        });

        replace([{ file: null }]);
        setPreviews({});
        setSuccess(true);
        setTimeout(() => setSuccess(false), 3000);
      } else {
        setShowError(res.payload.errors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              {/* Discipline */}
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>IS Standard Name</Form.Label>
                  <Form.Control
                    placeholder="IS Standard Name"
                    {...register("name", {
                      required: "IS Standard Name is required",
                    })}
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Remark</Form.Label>
                  <Form.Control
                    placeholder="Remark"
                    {...register("remark", {
                      required: "Remark is required",
                    })}
                  />
                  {errors.remark && (
                    <small className="text-danger">
                      {errors.remark.message}
                    </small>
                  )}
                </Form.Group>
              </div>

              {/* Documents */}
              {fields.map((item, index) => {
                const fileValue = watch(`documents.${index}`);

                // URL for preview
                const fileUrl =
                  typeof fileValue === "string"
                    ? process.env.REACT_APP_IMG_URL + fileValue
                    : fileValue?.[0]
                    ? URL.createObjectURL(fileValue[0])
                    : null;

                // Type detection
                const fileType =
                  typeof fileValue === "string"
                    ? fileValue.toLowerCase()
                    : fileValue?.[0]?.type;

                return (
                  <div className="col-md-6" key={item.id}>
                    <Form.Group className="form_group file_field">
                      <Form.Label>Attach IS Standard Document</Form.Label>

                      <div className="absolute_fields">
                        <Form.Control
                          type="file"
                          {...register(`documents.${index}`, {
                            validate: (value) => {
                              if (typeof value === "string" && value)
                                return true;

                              if (value && value.length > 0) return true;

                              return "File is required";
                            },
                          })}
                          accept="*"
                        />
                        {errors?.documents?.[index] && (
                          <p className="text-danger">
                            {errors.documents[index].message}
                          </p>
                        )}
                      </div>

                      {/* Preview Section */}
                      {fileUrl && (
                        <div className="image_holder mt-2">
                          {/* IMAGE */}
                          {(fileType?.includes("image") ||
                            fileType?.endsWith(".jpg") ||
                            fileType?.endsWith(".jpeg") ||
                            fileType?.endsWith(".png")) && (
                            <img
                              src={fileUrl}
                              alt="Preview"
                              style={{ maxWidth: "150px" }}
                            />
                          )}

                          {/* PDF */}
                          {(fileType === "application/pdf" ||
                            fileType?.endsWith(".pdf")) && (
                            <iframe
                              src={fileUrl}
                              title="PDF Preview"
                              style={{ width: "100%", height: "150px" }}
                            />
                          )}

                          {/* WORD */}
                          {(fileType?.includes("word") ||
                            fileType?.endsWith(".doc") ||
                            fileType?.endsWith(".docx")) && (
                            <div>
                              <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Open Word File
                              </a>

                              <iframe
                                src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                                style={{ width: "100%", height: "150px" }}
                                title="Word Preview"
                              />
                            </div>
                          )}

                          {/* EXCEL */}
                          {(fileType?.includes("spreadsheet") ||
                            fileType?.endsWith(".xlsx") ||
                            fileType?.endsWith(".xls")) && (
                            <div>
                              <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Open Excel File
                              </a>
                            </div>
                          )}
                        </div>
                      )}

                      {/* Remove Button */}
                      {index > 0 && (
                        <Button
                          type="button"
                          className="mt-2"
                          onClick={() => remove(index)}
                        >
                          Remove
                        </Button>
                      )}
                    </Form.Group>
                  </div>
                );
              })}

              {/* Add Another */}
              <div className="col-12">
                <div
                  className="add_another_holder"
                  onClick={() => append({ file: null })}
                >
                  <span>
                    <FontAwesomeIcon icon={faCirclePlus} /> Add Another Document
                  </span>
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="permission_btn_holder">
              {success ? (
                <Success_Toster successText="Saved Successfully!" />
              ) : (
                <>
                  <Button
                    type="button"
                    className="permission_btn No_btn"
                    onClick={handleCancel}
                  >
                    Reset
                  </Button>
                  <Button type="submit" className="permission_btn Yes_btn">
                    Save
                  </Button>
                </>
              )}
            </div>
          </Form>
        </div>
      </section>
    </>
  );
}

export default ISStandard_Form;
